import {
    FINANCIAL_LIST_REQUEST,
    FINANCIAL_LIST_SUCCESS,
    FINANCIAL_LIST_FAIL
} from '../constants/financialConstants'

export const financialListReducer = (state = {}, action) => {
    switch (action.type) {
        case FINANCIAL_LIST_REQUEST:
            return { loading: true }
        case FINANCIAL_LIST_SUCCESS:
            return { loading: false, financials: action.payload }
        case FINANCIAL_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

